import { apolloClient } from '~/apollo-client';
import { ContractVersion } from '~/services/fetch-vnm-terms';
import {
  Flex_CreateContractAgreementsMutation,
  Flex_CreateContractAgreementsMutationVariables,
} from '~/typings/graphql';
import { CREATE_CONTRACT_AGREEMENT } from './upload-contracts.queries';

export const uploadContracts = async (
  params: UploadContractsParams,
): Promise<UploadContractsResponse> => {
  const { userId, utilityAccountId, vnmSolarProjectContracts, file, externalSystem } = params;
  if (!vnmSolarProjectContracts?.length) return;

  const input = vnmSolarProjectContracts.map(contract => {
    const inputItem = {
      contractVersionId: contract.id,
      contractVersionLanguageId: contract.contractVersionLanguageId,
      utilityAccountId,
      userId,
      file,
    };

    return externalSystem
      ? {
          ...inputItem,
          externalSystem: {
            systemName: externalSystem,
          },
        }
      : inputItem;
  });

  const response = await apolloClient.mutate<
    Flex_CreateContractAgreementsMutation,
    Flex_CreateContractAgreementsMutationVariables
  >({
    mutation: CREATE_CONTRACT_AGREEMENT,
    variables: { input },
  });

  if (response.data?.createContractAgreements[0]?.success) {
    return true;
  } else {
    return false;
  }
};

export interface UploadContractsParams {
  userId: number;
  utilityAccountId: number;
  vnmSolarProjectContracts?: ContractVersion[];
  externalSystem?: string;
  file?: string;
}

export type UploadContractsResponse = boolean | void;
